import { connect } from 'react-redux';
import { get } from 'lodash';
import { Money } from '../../lib/money';

import MaxAllowedShare from '../../components/commit-form/maximum-allowed-share';
import { COMMIT_NAMESPACE } from '../../actions';
import { getCurrentPurchase } from '../../selectors/purchase-selector';

const mapStateToProps = ({ memberships, purchases, projections }) => {
  const membership = get(projections, `${COMMIT_NAMESPACE}.memberships.${memberships.current}`);
  const currentPurchase = getCurrentPurchase({ purchases });

  if (!membership || !currentPurchase) return {};

  return {
    claimedSlots: membership.claimedSlots,
    amount: membership.maxAmount,
    shareAmount: membership.maxShareAmount || Money.zero(currentPurchase.currencyCode),
    feesAmount: membership.maxFees.consumerFee,
  };
};

export default connect(mapStateToProps)(MaxAllowedShare);



// WEBPACK FOOTER //
// ./src/desktop/containers/commit-form/maximum-allowed-share.container.js